import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-sage-light" data-id="element-95" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-96" data-mp="1cf9lgbd305hl">
        <div className="text-center mb-16" data-id="element-97" data-mp="1cgb87d3gmgf5">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-ink" data-id="element-98" data-mp="2a2s54h8a6s0d">
            ❓ Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-99" data-mp="253xbek8rzj1h">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-white border border-sage rounded-xl overflow-hidden shadow-sm" data-id="element-100" data-mp="20315k14v5mtf" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-101" data-mp="1v7c8q5k8ak0t">
                <span className="font-bold text-lg text-ink pr-8" data-id="element-102" data-mp="1plibee9ft87o">{faq.q}</span>
                <ChevronDown className={`text-gold-dark transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-103" data-mp="1aqc0pdzecl80" />
              </button>
              <AnimatePresence data-id="element-104" data-mp="11wz4o361d3hp">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-105" data-mp="16np8hbytcyaa">
                    <div className="px-6 pb-5 text-charcoal border-t border-sage pt-4" data-id="element-106" data-mp="ww1hfc665j9c">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}